import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompanyChargesComponent } from './company-charges/company-charges.component';
import { SettlementDetailsNewComponent } from './settlement-details-new/settlement-details-new.component';
import { SettlementListComponent } from './settlement-list/settlement-list.component';
import { SettlementPrintableComponent } from './settlement-printable/settlement-printable.component';
import { STATEMENT_ID } from './settlement-statement-routing.constants';

const routes: Routes = [
  {
    path: 'list',
    component: SettlementListComponent,
  },
  {
    path: 'charges',
    component: CompanyChargesComponent,
  },
  {
    path: `print/:${STATEMENT_ID}`,
    component: SettlementPrintableComponent,
  },
  {
    path: `details/:${STATEMENT_ID}`,
    component: SettlementDetailsNewComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'list',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettlementStatementRoutingModule {}
